import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Offerte speciali',
  view_more: 'Vedi altro',
  badges: {
    PROMO: 'Promo',
    DEAL: 'Offerta',
    'FREE ITEM': 'Articolo gratuito',
    REWARDS: 'Premi',
  },
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Punti extra',
      description: 'Valutaci su Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      title: 'Offerta speciale',
      description: 'Già applicata automaticamente',
    },
    buttons: {
      add: 'Aggiungi',
      remove: 'Rimuovi',
      show_details: 'Mostra dettagli',
    },
    mobile_app_signup_bonus: {
      title: "{{amount}} Bonus di benvenuto sull'app",
      desc: 'Ottieni {{amount}} di cashback quando accedi alla nostra app.',
    },
    welcome_bonus: {
      title: '{{amount}} Bonus di benvenuto',
      desc: 'Ottieni {{amount}} di cashback quando ti registri.',
    },
  },
  discounts: {
    title: 'Sconto {{discount}}',
    usage_threshold: '(Min: {{amount}})',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: 'Sconto {{discount}} sul tuo prossimo ordine - codice: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]: 'Sconto {{discount}} sui tuoi prossimi {{count}} ordini - codice: {{code}}',
    },
  },
  feedback: {
    login:
      "<highlight>Accedi</highlight> per utilizzare questa promo così possiamo verificare che non l'abbia già usata. Accedi e riprova.",
  },
};
